var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFirends(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "friend",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "friend-2",
    "data-name": "friend",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3004",
    "data-name": "Path 3004",
    d: "M12.337,12.25H9.476c-4.541.006-8.22,4.185-8.226,9.342A4.23,4.23,0,0,0,5.184,26.06H16.628a4.23,4.23,0,0,0,3.934-4.468C20.557,16.435,16.877,12.256,12.337,12.25Z",
    transform: "translate(-1.25 -0.06)",
    fill: "#90348a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_102",
    "data-name": "Ellipse 102",
    cx: 6.591,
    cy: 6.591,
    r: 6.591,
    transform: "translate(3.065)",
    fill: "#90348a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3005",
    "data-name": "Path 3005",
    d: "M26.408,18.968a4.92,4.92,0,0,1-1.1,3.16,3.49,3.49,0,0,1-2.663,1.308H16.715a7.031,7.031,0,0,0,.11-1.219,11.618,11.618,0,0,0-3.984-9,5.889,5.889,0,0,1,4.326-1.966H19.9C23.5,11.254,26.405,14.707,26.408,18.968Z",
    transform: "translate(3.592 -0.685)",
    fill: "#90348a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3006",
    "data-name": "Path 3006",
    d: "M23.188,8.27a5.024,5.024,0,0,1-9.638,1.981,7.45,7.45,0,0,0,.268-1.981A7.351,7.351,0,0,0,13.55,6.3,5.02,5.02,0,0,1,23.188,8.27Z",
    transform: "translate(3.697 -1.224)",
    fill: "#90348a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFirends);
export default __webpack_public_path__ + "static/media/icon_firends.8699ef6c9102c18873a9cdf8dd4052ad.svg";
export { ForwardRef as ReactComponent };